import { Link } from "react-router-dom";
import { Linkedin, Mail, ArrowUpRight, Calendar, Github, FileText } from "lucide-react";

const expertise = [
  "AI Marketing",
  "Performance Marketing",
  "CRO",
  "Google Ads",
  "Meta Ads",
  "GA4",
  "GTM",
  "Marketing Automation",
];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-[#0F1115] text-white/70 border-t border-white/5"
  >
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-16">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        {/* Brand */}
        <div className="md:col-span-4">
          <div className="font-display text-2xl text-white tracking-tight leading-tight">
            AI Growth Marketing<br /> Consultant<span className="text-[#3B82F6]">.</span>
          </div>
          <p className="mt-4 text-sm max-w-sm">
            Shivani Ranawat · Founder, Aiadspace. I help startups and digital businesses grow faster using AI automation, performance marketing and CRO.
          </p>

          <div className="mt-6 space-y-2 text-sm">
            <a data-testid="footer-linkedin" href="https://www.linkedin.com/in/shivani-ranawat-a16929122/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white">
              <Linkedin size={14} /> LinkedIn <ArrowUpRight size={12} />
            </a><br />
            <a data-testid="footer-email" href="mailto:shivaniranawatdigitalworld@gmail.com" className="inline-flex items-center gap-2 hover:text-white break-all">
              <Mail size={14} /> shivaniranawatdigitalworld@gmail.com
            </a>
          </div>
        </div>

        {/* Expertise */}
        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Areas of Expertise</div>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {expertise.map((e) => (
              <li key={e} className="text-white/70 hover:text-white transition"><Link to="/services">{e}</Link></li>
            ))}
          </ul>
        </div>

        {/* Navigate */}
        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Navigate</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/work" className="hover:text-white">Case Studies</Link></li>
            <li><Link to="/insights" className="hover:text-white">Insights</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        {/* Direct */}
        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Direct</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a data-testid="footer-calendar" href="mailto:shivaniranawatdigitalworld@gmail.com?subject=Book%20a%20strategy%20call" className="inline-flex items-center gap-2 hover:text-white">
                <Calendar size={14} /> Book a strategy call
              </a>
            </li>
            <li>
              <span className="inline-flex items-center gap-2 text-white/40">
                <Github size={14} /> GitHub · coming soon
              </span>
            </li>
            <li>
              <span className="inline-flex items-center gap-2 text-white/40">
                <FileText size={14} /> Resume · request via email
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
        <div>© {new Date().getFullYear()} Shivani Ranawat · AI Growth Marketing Consultant. Marketing isn&apos;t about spending more — it&apos;s about converting better.</div>
        <div className="font-mono">v.2026.02 — Revenue Growth Engine™</div>
      </div>
    </div>
  </footer>
);
